import { useState, useEffect } from "react";

export function useMatomoExperiment(experimentName: any, variationsList: any) {
  const [variant, setVariant] = useState("original");

  useEffect(() => {
    // CRA executes this entirely in the user's browser
    // @ts-ignore
    if (window.Matomo && window.Matomo.AbTesting) {
      // @ts-ignore
      //   console.log(window);
      // @ts-ignore
      const Experiment = window.Matomo.AbTesting.Experiment;
      const exp = new Experiment({
        name: experimentName,
        variations: variationsList.map((v: any) => ({
          name: v,
          activate: () => {}, // Handled via React state instead of Matomo DOM mutation
        })),
      });

      console.log(
        "exp.getActivatedVariationName()",
        exp.getActivatedVariationName(),
      );

      setVariant(exp.getActivatedVariationName());
    }
  }, [experimentName, variationsList]);

  return variant;
}
